import React from 'react';
import {
  Box,
  Container,
  Grid, 
  Typography,
  Button,
  Card,
  CardContent,

} from '@mui/material';
import {

  FaUserCog,

  FaUserTie,
  FaBuilding,
 
  FaMousePointer,
  FaBolt,
  FaClock,
  FaEye,
  FaLock,
  FaHeadset, 
} from 'react-icons/fa';
import Header from '../header/header';
import Footer from '../commun/Footer';
import './Services.css';
import './Home.css';

const Services = () => {

  return (
    <Box className="services">
      <Header />
<Box className="hero-image-wrapper">
  <picture>
    <source media="(max-width: 768px)" srcSet="/images/services/hero-mobile.webp" />
    <source media="(max-width: 1280px)" srcSet="/images/services/hero-tablet.webp" />
    <img
      src="/images/services/hero-desktop.webp"
      alt="Bannière Services Cooptaleo"
      className="hero-img"
    />
  </picture>
  <Box className="hero-overlay">
    <Container maxWidth="lg">
      <Box className="hero-content">
        <Typography variant="h3" className="hero-title" align="left">
          Trouvez les bons profils, au bon moment,
        </Typography>
        <Typography variant="h3" className="hero-title" align="left">
          sans perdre de temps
        </Typography>
        <Typography variant="h6" className="hero-subtitle">
          Recruteurs indépendants et entreprises collaborent efficacement via une plateforme unique, boostée par l’IA. Moins de démarches, plus de résultats.
        </Typography>
        <Button
          variant="contained"
          className="hero-button hero-inscription"
          href="signup"
          color="primary"
        >
          Commencer maintenant
        </Button>
      </Box>
    </Container>
  </Box>
</Box>


      <Box className="section-spacing-large">
        <Container maxWidth="md">
          <Typography variant="h4" align="center" gutterBottom className="section-main-title titles">
          Une seule plateforme, trois promesses
          </Typography>
          <Typography variant="body1" align="center" className="section-intro-text">
          Entreprises, recruteurs, experts IT… Grâce à l’IA, Cooptaleo simplifie le recrutement en réunissant tous les acteurs et outils clé sur une plateforme unique, conçue pour l’efficacité, la fluidité et la performance. 
          </Typography>
        </Container>
      </Box>

     <Box id="explore-services" className="services-by-profile-section-home">
  <Container>
    <Typography variant="h4" align="center" gutterBottom className="section-main-profil titles">
Des services adaptés à chaque besoin
    </Typography>
            
    <Box className="services-cards-flex-container">

      {/* Service pour les Entreprises */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaBuilding className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
           <strong> Entreprises </strong>
          </Typography>
           <Typography  align="center" className="value-title-service">
                              <strong> Accédez à un réseau de recruteurs indépendants experts en IT.</strong>
                              </Typography>
                              <p></p>
          <Typography variant="body2" align="center" className="service-card-description">
Publiez vos besoins en quelques clics, recevez des profils ciblés et suivez vos recrutements depuis une interface simple, fluide et pensée pour votre efficacité.       </Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/entreprise">
              Inscrire ma société
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Service pour les Recruteurs */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaUserTie className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
            <strong>Recruteurs indépendants</strong>
          </Typography>
          <Typography  align="center" className="value-title-service">
                              <strong> Rejoignez une plateforme dédiée aux missions IT qualifiées.</strong>
                              </Typography>
                              <p></p>
          <Typography variant="body2" align="center" className="service-card-description">
Proposez vos talents sur des missions qualifiées, suivez vos candidatures en temps réel et recevez des commissions selon vos résultats sur la plateforme.</Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/recruteur">
              Rejoindre le réseau
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Service pour les Talents */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaUserCog className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
            <strong>Experts IT</strong>
          </Typography>
          <Typography  align="center" className="value-title-service">
                              <strong>Déposez votre CV et laissez des recruteurs IT qualifiés vous contacter.</strong>
                              </Typography>
                              <p></p>
          <Typography variant="body2" align="center" className="service-card-description">
Rendez votre profil visible des recruteurs IT, recevez des opportunités ciblées et mettez à jour vos informations quand vous le souhaitez, sans avoir à postuler.       </Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/candidat">
              Déposer un CV
            </Button>
          </Box>
        </CardContent>
      </Card>

    </Box>
  </Container>
</Box>

      <Box className="section-spacing-large advantages-section">
        <Container>
          <Typography variant="h4" align="center" gutterBottom className="section-main-title titles">
          Une expérience simple, fluide et sécurisée
          </Typography>
          <Typography variant="h6" align="center" gutterBottom>
          Du besoin au recrutement, sans friction 
            </Typography>
          <Typography variant="body1" align="center" gutterBottom>
          Cooptaleo change les règles du jeu du recrutement IT en misant sur l’intelligence artificielle, la transparence et des mises en relation ciblées.  
          </Typography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}> 
          {[
            {
              icon: <FaMousePointer className="advantage-icon" />,
              title: 'Interface intuitive',
              desc: 'Prenez en main la plateforme sans effort.',
            },
            {
              icon: <FaBolt className="advantage-icon" />,
              title: 'Processus accéléré',
              desc: 'Réduisez les étapes et gagnez en efficacité.',
            },
            {
              icon: <FaClock className="advantage-icon" />,
              title: 'Suivi en temps réel',
              desc: 'Gardez une vision claire à chaque instant.',
            },
            {
              icon: <FaEye className="advantage-icon" />,
              title: 'Transparence totale',
              desc: 'Visualisez toutes les interactions, sans zones d’ombre.',
            },
            {
              icon: <FaLock className="advantage-icon" />,
              title: 'Données protégées',
              desc: 'Protégez vos informations dans un cadre 100% sécurisé.',
            },
            {
              icon: <FaHeadset className="advantage-icon" />,
              title: 'Support dédié',
              desc: 'Bénéficiez d’un accompagnement réactif et personnalisé.',
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className="my-card">
                <CardContent>
                  <Box className="my-icon">{item.icon}</Box>
                  <Typography variant="h6" align="center">{item.title}</Typography>
                  <Typography variant="body2" align="center">{item.desc}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
            </Grid>
        </Container>
      </Box>

      <Box className="services-by-profile-section">
        <Container>
          <Typography variant="h4" align="center" gutterBottom className="section-main-title titles">
          L’intelligence artificielle au service de vos ambitions IT
          </Typography>
          <Typography variant="h6" align="center" gutterBottom>
           Recrutez plus vite. Recrutez plus juste. Grâce à l’IA. 
            </Typography>
          <Typography variant="body1" align="center" gutterBottom>
           Cooptaleo aligne besoins, compétences et expertise IT avec une technologie de matching intelligente et fluide. Moins de friction. Plus de résultats.   
          </Typography>
          <Box className="section-spacing-home" />
          <Grid container spacing={4} justifyContent="center">
          {[
            {
              title: 'Matching intelligent',
              desc: 'L’IA analyse vos besoins et vous propose automatiquement les profils les plus pertinents.',
              img: 'https://img.icons8.com/color/96/artificial-intelligence.png',
            },
            {
              title: 'Parsing de CV automatisé',
              desc: 'Les informations clés des CV (PDF, Word, image) sont extraites pour une lecture immédiate.',
              img: 'https://img.icons8.com/color/96/document--v1.png',
            },
            {
              title: 'Détection de doublons',
              desc: 'L’algorithme repère les profils similaires ou déjà présents pour éviter les répétitions.',
              img: 'https://img.icons8.com/color/96/resume.png',
            },
            {
              title: 'Suggestions dynamiques',
              desc: 'Recevez des recommandations ciblées selon vos habitudes et vos précédents résultats.',
              img: 'https://img.icons8.com/color/96/combo-chart--v1.png',
            },
            {
              title: 'Analyse des performances',
              desc: 'Suivez vos actions et améliorez vos recrutements grâce à des indicateurs intelligents.',
              img: 'https://img.icons8.com/color/96/speed.png',
            },
            {
              title: 'Structuration automatique des données',
              desc: 'Les profils sont nettoyés, normalisés et prêts à l’emploi, sans effort manuel.',
              img: 'https://img.icons8.com/color/96/data-configuration.png',
            },
          ].map((item, index) => (
             <Grid item className="why-grid-item" key={index}>
              <Box className="why-card-clean">
                <Box className="why-img-container">
                  <img src={item.img} alt={item.title} className="why-img" />
                </Box>
                <Typography variant="subtitle1" className="why-title" align="center">
                  {item.title}
                </Typography>
                <Typography variant="body2" className="why-desc" align="center">
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        </Container>
      </Box>
       <Box className="steps-section">
          <Container maxWidth="md" style={{ textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom className='titles'>
              Prêt à transformer vos recrutements ?
            </Typography>
            <Typography variant="body1" className="cta-subtitle">
              Découvrez comment Cooptaleo peut vous aider à recruter mieux, plus vite, et plus simplement.
            </Typography>
            <Box mt={3}>
              <Button variant="contained" color="primary" size="large" href= "signup">
                Créer un compte gratuitement
              </Button>
            </Box>
          </Container>
        </Box>
      <Footer />
    </Box>
  );
};

export default Services;